<template>
  <!-- eslint-disable vue/max-attributes-per-line vue/no-static-inline-styles -->
  <section class="sa-loader">
    <div class="card wavebg mb-24">
      <h5 class="card-title">
        Referal URLs
      </h5>
      <hr>
      <div class="card-body row pb-0 pt-0">
        <div class="col-md-6 col-12 pb-0 padding-right pl-0">
          Involve users and receive a regular income from all their payments.
          <br>
          <br>
          Use the links to attract your referrals. All registered users will be permanently added to your referrals. To all visitors, who came from your link, we will set the cookie for 30 days - registration in that period will be counted as your referral.
        </div>
        <div class="col-md-6 col-12 padding-left">
          <div>
            <h6>HOMEPAGE URL</h6>
            <div class="text-green">
              https://affstaging.pw/?ref=b0eciy5d8dauc
            </div>
            <br>
            <h6>REGISTRATION URL</h6>
            <div class="text-green">
              https://affstaging.pw/auth/register?ref=b0eciy5d8dauc
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="card wavebg !tw-w-full">
      <div class="!tw-flex sa-header !tw-justify-between !tw-items-center">
        <div class="!tw-flex !tw-items-center">
          <div class="">
            Sub-Affiliates Accounts
          </div>
        </div>
        <div
          class="empty-pagination"
          style="width: 269px"
        >
          <div
            class="empty-select mr-8"
            style="width: 80px"
          >
            100
          </div>
          <span>&lt; &lt;&lt; Page</span>
          <div class="form-group mb-0 mt-0">
            <input
              placeholder="1"
              class="form-control mt-0 pl-16 pr-16"
              style="width: 40px"
            >
          </div>
          <span>of 2 > >></span>
        </div>
      </div>
      <div class="table-empty mt-16 mb-8">
        <div class="table-empty__head">
          <!-- <div class="cell">Promocode</div>
            <div class="cell">Promocode</div>
            <div class="cell">Promocode</div>
            <div class="cell">Promocode</div>
            <div class="cell">Actions</div> -->
        </div>
        <div class="table-empty__body">
          <!-- <div class="table-empty__body-row">
              <div class="cell">+100500</div>
              <div class="cell">Promocode</div>
              <div class="cell">!@#$%^&*){}/*++</div>
              <div class="cell">!@#$%^&*){}/*++</div>
              <div class="cell text-red">Delete</div>
            </div>
            <div class="table-empty__body-row">
              <div class="cell">+100500</div>
              <div class="cell">Promocode</div>
              <div class="cell">!@#$%^&*){}/*++</div>
              <div class="cell">!@#$%^&*){}/*++</div>
              <div class="cell text-red">Delete</div>
            </div>
            <div class="table-empty__body-row">
              <div class="cell">+100500</div>
              <div class="cell">Promocode</div>
              <div class="cell">!@#$%^&*){}/*++</div>
              <div class="cell">!@#$%^&*){}/*++</div>
              <div class="cell text-red">Delete</div>
            </div>
            <div class="table-empty__body-row">
              <div class="cell">+100500</div>
              <div class="cell">Promocode</div>
              <div class="cell">!@#$%^&*){}/*++</div>
              <div class="cell">!@#$%^&*){}/*++</div>
              <div class="cell text-red">Delete</div>
            </div> -->
        </div>

        <div class="mob-table__block mob-table__block-actions pt-0">
          <div class="table-empty__row !tw-justify-between">
            <span>Promocode</span>
            <span>0</span>
          </div>
          <div class="table-empty__row !tw-justify-between">
            <span>Promocode</span>
            <span>0</span>
          </div>
          <div class="table-empty__row !tw-justify-between">
            <span>Promocode</span>
            <span>0</span>
          </div>
          <div class="table-empty__row !tw-justify-between">
            <span>Promocode</span>
            <span>0</span>
          </div>
          <div class="mob-table__actions">
            <span class="text-green">Promocode</span>
            <span class="text-red">Promocode</span>
          </div>
        </div>
        <div class="mob-table__block mob-table__block-actions">
          <div class="table-empty__row !tw-justify-between">
            <span>Promocode</span>
            <span>0</span>
          </div>
          <div class="table-empty__row !tw-justify-between">
            <span>Promocode</span>
            <span>0</span>
          </div>
          <div class="table-empty__row !tw-justify-between">
            <span>Promocode</span>
            <span>0</span>
          </div>
          <div class="table-empty__row !tw-justify-between">
            <span>Promocode</span>
            <span>0</span>
          </div>
          <div class="mob-table__actions">
            <span class="text-green">Promocode</span>
            <span class="text-red">Promocode</span>
          </div>
        </div>
        <div class="mob-table__block mob-table__block-actions">
          <div class="table-empty__row !tw-justify-between">
            <span>Promocode</span>
            <span>0</span>
          </div>
          <div class="table-empty__row !tw-justify-between">
            <span>Promocode</span>
            <span>0</span>
          </div>
          <div class="table-empty__row !tw-justify-between">
            <span>Promocode</span>
            <span>0</span>
          </div>
          <div class="table-empty__row !tw-justify-between">
            <span>Promocode</span>
            <span>0</span>
          </div>
          <div class="mob-table__actions">
            <span class="text-green">Promocode</span>
            <span class="text-red">Promocode</span>
          </div>
        </div>
        <div class="mob-table__block mob-table__block-actions">
          <div class="table-empty__row !tw-justify-between">
            <span>Promocode</span>
            <span>0</span>
          </div>
          <div class="table-empty__row !tw-justify-between">
            <span>Promocode</span>
            <span>0</span>
          </div>
          <div class="table-empty__row !tw-justify-between">
            <span>Promocode</span>
            <span>0</span>
          </div>
          <div class="table-empty__row !tw-justify-between">
            <span>Promocode</span>
            <span>0</span>
          </div>
          <div class="mob-table__actions">
            <span class="text-green">Promocode</span>
            <span class="text-red">Promocode</span>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<style lang="scss">
// @import 'src/assets/theme/default/components/styles-loaders';

.sa-loader{
  @media (max-width: 650px){
    .sa-header{
      display: block !important;
      padding-bottom: 16px;
      border-bottom: 1px solid #e7ecf1;
      .empty-pagination{
        margin-top: 12px !important;
      }
    }
  }
}
</style>
